import { Grid, H2, H3 } from '@daren/ui-components'
import * as React from 'react'

import { OptimizedImage } from '../elements/optimized-image'

import { getLowQualityUrlFor } from '~/lib/sanity'

import type { SanityImage } from '~/types/sanity'
import { getResponsiveImageSizes } from '~/utils/image'

export interface HeroProps {
  title?: string
  subTitle?: React.ReactNode
  image?: SanityImage | string
  as?: React.ElementType
}

function Hero({ as = 'header', title, subTitle, image }: HeroProps) {
  return (
    <Grid
      as={as}
      className="items-start mb-12 h-auto lg:pb-12 lg:min-h-[40rem]"
    >
      {image && (
        <div className="flex flex-col col-span-full w-full aspect-w-3 aspect-h-4 sm:flex-row sm:col-span-2 md:col-span-4 lg:col-span-6">
          {typeof image === 'string' ? (
            <OptimizedImage
              src={image}
              className="object-contain absolute inset-0 w-full h-full"
            />
          ) : (
            <OptimizedImage
              {...image}
              blurDataUrl={getLowQualityUrlFor(image)}
              className="object-contain absolute inset-0 w-full h-full"
              alt={image.alt}
              responsive={getResponsiveImageSizes('medium')}
            />
          )}
        </div>
      )}
      <div className="flex col-span-full w-full h-full sm:col-span-2 sm:items-center md:col-span-4 lg:col-span-6">
        <div className="flex w-full">
          <div className="w-full">
            {title && (
              <H2 className="inline-block py-3 px-4 m-0 font-title text-2xl font-black whitespace-nowrap -translate-y-full sm:text-4xl sm:-translate-x-1/2 sm:translate-y-0 md:text-6xl lg:text-8xl bg-primary">
                {title}
              </H2>
            )}
            {subTitle ? (
              <H3 variant="secondary" className="mt-6 mb-12">
                {subTitle}
              </H3>
            ) : null}
          </div>
        </div>
      </div>
    </Grid>
  )
}

export { Hero }
